module.exports = __webpack_public_path__ + "media/images/thank-you-hero-6a55310b1d28d4917328d3d23517603d.jpg";